export const checkNewNoti = (arr) => {
    //return boolean
    return arr.some((item) => item.seen === false);
};
